import { render, staticRenderFns } from "./FaqQuestionModal.vue?vue&type=template&id=779b7b4c&scoped=true&"
import script from "./FaqQuestionModal.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b7b4c",
  null
  
)

export default component.exports